import React from "react";
import { Link } from "react-router-dom";
import { Cpu, ArrowRight } from "lucide-react";

export const AICourseBanner = () => (
  <Link
    to="/ai-workers-school"
    className="block bg-gradient-to-r from-cyan-950 via-slate-900 to-cyan-950 border-b border-cyan-400/40 hover:from-cyan-900 hover:to-cyan-900 transition-colors"
    data-testid="ai-course-home-banner"
  >
    <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center justify-center gap-2 sm:gap-3 flex-wrap text-center">
      <span className="inline-flex items-center gap-1.5 bg-cyan-400 text-slate-950 text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider">
        <Cpu className="w-3 h-3" /> New Free Course
      </span>
      <span className="text-white font-black text-sm sm:text-base">AI &amp; Workers</span>
      <span className="hidden sm:inline text-cyan-200/80 text-sm">— AI literacy for working people, no tech background needed</span>
      <span className="inline-flex items-center gap-1 text-cyan-300 font-black text-sm underline underline-offset-4">
        Start now <ArrowRight className="w-3.5 h-3.5" />
      </span>
    </div>
  </Link>
);
